import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { DelegadoTipoProcesoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class DelegadoTipoProcesoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getDelegadoTipoProcesoService(): Observable<BodyListResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyListResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/todos');
  }

  getDelegadoTipoProcesoPorProcesoService(codigo: string): Observable<BodyListResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyListResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/tipoProceso/' + codigo);
  }

  getDelegadoTipoProcesoPorFlujoService(codigo: string): Observable<BodyListResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyListResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/flujo/' + codigo);
  }

  getDelegadoTipoProcesoPorNumeroIdentificacionService(numeroIdentificacion: string, tipoProceso: string): Observable<BodyListResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyListResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/numeroIdentidad/' + numeroIdentificacion + '/tipoPorceso/' + tipoProceso);
  }

  guardarDelegadoTipoProcesoService(delegadoTipoProcesoDTO: DelegadoTipoProcesoDTO): Observable<BodyResponse<DelegadoTipoProcesoDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/delegadoTipoProceso', delegadoTipoProcesoDTO);
  }

  getDelegadoTipoProcesoPorCodigoService(codigo: string): Observable<BodyResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/' + codigo);
  }

  /******************************************** */
  getDelegadoTipoProcesoPorCodigoSolicitudService(codigoSolicitud: string): Observable<BodyListResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyListResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/solicitud/' + codigoSolicitud);
  }

  getDelegadoTipoProcesoPorCarreraPorFlujoCodigoBusquedaService(codigoCarrera: string, codigoBusqueda: string): Observable<BodyListResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyListResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/carrera/' + codigoCarrera + '/codigo_busqueda/' + codigoBusqueda);
  }

  /******************************************** */

  getDelegadoTipoProcesoPorEscuelaService(codigo: string): Observable<BodyListResponse<DelegadoTipoProcesoDTO>> {
    return this.http.get<BodyListResponse<DelegadoTipoProcesoDTO>>(API_URL + '/api/v1/delegadoTipoProceso/escuela/' + codigo);
  }
}
